var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"virtual-coupon-wrapper"},[_c('div',{staticClass:"bg"},[_c('img',{attrs:{"src":_vm.H5Bg || _vm.info.bgImg,"alt":""}})]),_c('div',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.title))]),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.info.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }